import { Component, OnInit, Input, TemplateRef, SimpleChanges, OnChanges } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { trigger, transition, style, animate, state, query, animateChild } from '@angular/animations';

@Component({
  selector: 'app-panel-header-image-view',
  templateUrl: './panel-header-image-view.component.html',
  styleUrls: ['./panel-header-image-view.component.scss'],
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0.7 }),
        animate('1000ms', style({ opacity: 1 })),
        query('@*', animateChild(), { optional: true }),

      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('1000ms', style({ opacity: 0.7 })),
        query('@*', animateChild(), { optional: true }),
      ])
    ]),
    trigger('navigate', [
      state('in', style({ 'opacity': '1' })),
      state('out', style({ 'opacity': '0.7' })),

      transition('* <=> *', [
        animate('1500ms'),
        query('@*', animateChild(), { optional: true }),

      ])
    ]),
    trigger('heightAnimation', [
      transition(':enter', [
        query('@*', animateChild(), { optional: true }),
        style({ paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0, opacity: 0 }),
        animate('1500ms', style({ opacity: 1 }))
      ]),

      transition(':leave', [
        query('@*', animateChild(), { optional: true }),
        style({ height: '*', paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0, opacity: 1 }),
        animate('1500ms', style({ height: 0, paddingTop: 0, paddingRight: 0, paddingBottom: 0, paddingLeft: 0, opacity: 0 })),

      ]),

    ]),


  ]
})
export class PanelHeaderImageViewComponent implements OnInit {

  showNav = false;
  @Input()
  title: string;
  @Input()
  banner_image: string;
  @Input()
  pretitle: string;
  @Input()
  downtitle: string;
  @Input()
  logo: boolean;

  /**
   * A property to define custom template for advanced use
   *
   * @type {boolean}
   * @memberof PanelHeaderImageViewComponent
   */
  @Input()
  customTemplate: boolean = false;

  /**
   * A property for set a custom template into the level of title
   *
   * @type {TemplateRef}
   * @memberof PanelHeaderImageViewComponent
   */
  @Input()
  templateTitle: TemplateRef<any>;

  @Input()
  navigationAnimationState:string = 'in';

  @Input()
  customTitleSet=false;

  constructor(router: Router, _activated: ActivatedRoute) {
    router.events
      .pipe(filter(a => a instanceof NavigationStart))
      .subscribe(next => {
        if (next instanceof NavigationStart) {
          switch (next.url) {
            case "/world-ranking":
              this.title = "World_ranking";
              this.banner_image = "../../../modules/custom/wa_angular/app/assets/images/banner-world-ranking.jpg";
              break;
            case "/world-cup-ranking":
              this.title = "world_cup_ranking";
              this.banner_image = "../../../modules/custom/wa_angular/app/assets/images/banner-world-cup-ranking.jpg";
              break;
            case "/world-records":
              this.title = "world_record";
              this.banner_image = "../../../modules/custom/wa_angular/app/assets/images/banner-world-records.jpg";
              break;
            case "/prize-precision":
              this.title = "Prizeforprecision";
              this.banner_image = "../../../modules/custom/wa_angular/app/assets/images/banner-world-cup-ranking.jpg";
              break;
            case "/members":
              this.title = "members.archery_federations";
              this.banner_image = "../../../modules/custom/wa_angular/app/assets/images/test-image-members2.jpg";
              break;
            default:
          }
        }
      });
  }
  ngOnInit() {
  }

}
